<template>
  <div :class="['form-group w-100 mb-0', customClass.containerClass]">
    <label v-if="label" :class="[customClass.labelClass]" :for="id">{{
      label
    }}</label>
    <div class="position-relative">
      <div v-if="!disabled" class="arrow-icon">
        <slot name="side-icon">
          <i class="fa fa-chevron-down"></i>
        </slot>
      </div>
      <div class="placeholder" :class="{ 'bg-grey': disabled }">
        <span v-if="!displayedValue">
          {{ placeholder }}
        </span>
      </div>
      <div
        class="selected-value"
        :class="{ 'bg-grey': disabled }"
        v-if="displayedValue"
      >
        <span>{{ displayedValue }}</span>
      </div>
      <select
        @change="onchange"
        @blur="onblur"
        :class="[
          'form-control',
          { 'text-muted': !currentValue || currentValue === '' },
          customClass.inputClass,
        ]"
        :id="id"
        v-model="currentValue"
        :disabled="disabled"
      >
        <!-- <option v-if="placeholder" value="" disabled>
          {{ placeholder }}
        </option> -->

        <slot name="options">
          <option
            v-for="(option, index) in options"
            :key="index"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </slot>
      </select>
    </div>
    <small class="text-danger" v-if="currentError">{{ currentError }}</small>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
      required: true,
    },
    customClass: {
      type: Object,
      default: () => ({ containerClass: "", labelClass: "", inputClass: "" }),
    },
    id: { type: String, required: true },
    value: { type: String, required: true },
    placeholder: { type: String, default: "", required: false },
    error: { type: String, default: "", required: false },
    label: { type: String, default: "", required: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      currentError: this.error,
      currentValue: this.value,
    };
  },
  computed: {
    displayedValue() {
      const selected = this.options.find(
        (option) => option.value == this.currentValue
      );
      if (selected) {
        return selected.label;
      }
      return "";
    },
  },
  methods: {
    onchange(event) {
      if (event.target.value) this.currentError = "";
      this.$emit("change", event.target.value);
    },
    onblur(event) {
      if (this.required && !event.target.value) {
        this.currentError = "This field is required";
      }
      this.$emit("blur", event.target.value);
    },
  },
  watch: {
    error(value) {
      this.currentError = value;
    },
    value(value) {
      this.currentValue = value;
    },
  },
};
</script>

<style scoped>
.arrow-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6c757d;
}

.input-single-select {
  width: 100%;
}

option {
  color: #374151;
}

option[value=""][disabled] {
  display: none;
}

.text-muted,
input::placeholder {
  font-size: 1rem;
  color: #2e364666 !important;
  opacity: 1 !important; /* Firefox */
}

select {
  font-size: 1rem;
  appearance: none; /* Standard */
  -webkit-appearance: none; /* Safari/Chrome */
  -moz-appearance: none; /* Firefox */
  background: none; /* Removes background image (arrow) */
  height: 40px;
  border-radius: 6px;
}

label {
  color: #374151;
  font-weight: 600;
  font-size: 14px;
}
.placeholder {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #2e364666;
  pointer-events: none;
  background-color: #ffffff;
  width: calc(100% - 40px);
}

.selected-value {
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  color: #374151;
  pointer-events: none;
  background-color: #ffffff;
  width: calc(100% - 40px);
}

.bg-grey {
  background-color: #e9ecef;
}
</style>



// WEBPACK FOOTER //
// src/components/Input/SingleSelect.vue